import type * as Types from 'app/types/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopPlatformsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.ShopPlatformOrder>;
  where?: Types.InputMaybe<Types.ShopPlatformWhereInput>;
}>;

export type ShopPlatformsQueryResponse = {
  shopPlatforms?: Types.Maybe<{
    edges?: Types.Maybe<
      Array<
        Types.Maybe<{
          node?: Types.Maybe<
            Pick<
              Types.ShopPlatform,
              | 'appType'
              | 'id'
              | 'currency'
              | 'platform'
              | 'status'
              | 'platformDomain'
              | 'platformStoreID'
            >
          >;
        }>
      >
    >;
  }>;
};

export const ShopPlatformsDocument = `
    query ShopPlatforms($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: ShopPlatformOrder, $where: ShopPlatformWhereInput) {
  shopPlatforms(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    where: $where
  ) {
    edges {
      node {
        appType
        id
        currency
        platform
        status
        platformDomain
        platformStoreID
      }
    }
  }
}
    `;

export const useShopPlatformsQuery = <TData = ShopPlatformsQueryResponse, TError = unknown>(
  variables?: ShopPlatformsQueryVariables,
  options?: UseQueryOptions<ShopPlatformsQueryResponse, TError, TData>,
) => {
  return useQuery<ShopPlatformsQueryResponse, TError, TData>(
    variables === undefined ? ['ShopPlatforms'] : ['ShopPlatforms', variables],
    appFetcher<ShopPlatformsQueryResponse, ShopPlatformsQueryVariables>(
      ShopPlatformsDocument,
      variables,
    ),
    options,
  );
};

useShopPlatformsQuery.getKey = (variables?: ShopPlatformsQueryVariables) =>
  variables === undefined ? ['ShopPlatforms'] : ['ShopPlatforms', variables];
